import {
  apiURL
} from '../../config/app';
const querystring = require('querystring')

const getExpenses = async ({ authToken, from, to, page, limit = 20, lastEvaluatedKey }) => {
  let query;
  if (lastEvaluatedKey) {
    query = querystring.stringify(lastEvaluatedKey)
  }
  const response = await fetch(`${apiURL}/expenses?from=${from}&to=${to}&limit=${limit}&page=${page}${lastEvaluatedKey ? `&${query}` : ''}`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

const addExpenses = async ({ payload, authToken }) => {
  const response = await fetch(`${apiURL}/expenses`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    body: JSON.stringify(payload)
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

const editExpenses = async ({ payload, authToken }) => {
  const response = await fetch(`${apiURL}/expenses/${[payload.id]}`, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    body: JSON.stringify(payload)
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

const deleteExpenses = async ({ payload, authToken }) => {
  const response = await fetch(`${apiURL}/expenses/${[payload.id]}`, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

export default {
  getExpenses,
  addExpenses,
  editExpenses,
  deleteExpenses
};



// WEBPACK FOOTER //
// ./api/expenses.js